/**
 * Fetches event data for all event IDs present on the page.
 * Assumes event IDs are stored in elements with a data attribute 'data-eventid'.
 * @returns AvailableEvents - A promise that resolves to the fetched events data or null.
 * @param privatApiKey - The api privat Key.
 * @param eventBucketId - The event bucket id.
 */
export async function fetchEventsFromPage(privatApiKey, eventBucketId) {

  const eventElements = document.querySelectorAll('[data-eventid]');
  const eventIds = Array.from(eventElements).map(el => el.getAttribute('data-eventid'));

  if (eventIds.length === 0) {
    console.warn('fetchEventsFromPage : No event IDs found on the page.');
    return null;
  }
  const apiUrl = `https://api.eventive.org/event_buckets/${eventBucketId}/events?event_ids=${encodeURIComponent(JSON.stringify(eventIds))}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Basic ${btoa(privatApiKey)}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      console.error(`fetchEventsFromPage: Error fetching events: ${response.statusText}`);
      return null;
    }

    // console.log('Fetched event data:', await response.json());
    return await response.json();
  } catch (error) {
    console.error('fetchEventsFromPage: Failed to fetch event data:', error);
    return null;
  }
}

